import styled from 'styled-components';
import * as RadioStyles from 'components/core/Radio/Radio.styles';

export const AgreementContainer = styled.div`
  padding: 20px;
  margin-top: 50%;
`;

export const ModalTitle = styled.div`
  font-weight: 600;
  font-size: 1.1rem;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 8.5px;
  /* border: 1px solid blue; */
`;

export const Terms = styled.div`
  font-weight: 400;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
`;

export const TermsText = styled.p``;

export const Link = styled.a`
  color: rgba(32, 154, 214, 1);
  display: inline;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
`;

export const ActionButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  > button {
    margin-left: 5px;
  }
`;

export const ReviewConfirmationActionButtons = styled.div`
  display: flex;
  width: 100%;
  margin-top: 20px;
  justify-content: flex-end;
  flex-direction: row;
  > button {
    margin-left: 5px;
  }  
  line-height: 24px;
`;

export const LoadingMessage = styled.div`
  font-weight: 400;
  font-size: 0.8rem;
`;

export const ReviewConfirmationContainer = styled.div`
  padding: 20px;
  margin-top: 50%;
  background: white;
  border-radius: 5px;
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ReviewConfirmationSuccessContainer = styled.div`
  padding: 20px;
  margin-top: 50%;
  background: white;
  border-radius: 5px;
`;

export const ReviewSuccessMessage = styled.div`
  font-weight: 500;
  font-size: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  > button {
    margin-top: 10px;
  }
  `;

export const CloseAgreementModal = styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
`;

export const DownloadBody = styled.div`
  border-radius: 0px 5px 5px 5px;
  padding: 5px 5px;
  font-weight: 400;
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.63);
  margin-top: 2%;
  font-weight: 400;
  text-align: center;
`;

export const Description = styled.div`
  border-radius: 0px 5px 5px 5px;
  padding: 5px 5px;
  font-weight: 400;
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.63);
  margin-top: 2%;
  font-weight: 400;
`;

export const DownloadConfirmationModalBody = styled.div`
  margin-top: 50%;

  padding: 20px;
  font-weight: 500;
  line-height: 24px;
`;
export const DownloadConfirmationModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  padding: 0px 20px 20px 20px;
  > button {
    margin-left: 5px;
  }
    `;


export const FileFormatWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding-left: 8.5px;

  p {
    font-size: 16px;
  }
    `;

 export const FormatOptionItem = styled.div`
   display: flex;
  
   ${RadioStyles.OuterCircle} {
    margin-right: 0;
  }
`;
